const TYPES = {
  RECEIVE_AUTH_DATA: '@user/RECEIVE_AUTH_DATA',
  UPDATE_EDIT_BOOKING_ID: '@user/UPDATE_EDIT_BOOKING_ID',
  UPDATE_EDIT_NAME: '@user/UPDATE_EDIT_NAME',
  UPDATE_EDIT_NAME_STEP: '@user/UPDATE_EDIT_NAME_STEP',
  UPDATE_SELECTED_BOOKING_PASSENGER: '@user/UPDATE_SELECTED_BOOKING_PASSENGER',
};

const receiveCSAUserAuthData = (csaUserAuthData) => ({
  csaUserAuthData,
  type: TYPES.RECEIVE_AUTH_DATA,
});

const updateBookingId = (bookingId) => ({
  bookingId,
  type: TYPES.UPDATE_EDIT_BOOKING_ID,
});

const updateEditNames = ({ firstName, lastName, userType }) => ({
  firstName,
  lastName,
  type: TYPES.UPDATE_EDIT_NAME,
  userType,
});

const updateEditNameStep = (formStep) => ({
  formStep,
  type: TYPES.UPDATE_EDIT_NAME_STEP,
});

const updateSelectedBookingPassenger = ({ bookingId, cruiseName, passengerNumber }) => ({
  bookingId,
  cruiseName,
  passengerNumber,
  type: TYPES.UPDATE_SELECTED_BOOKING_PASSENGER,
});

export {
  receiveCSAUserAuthData,
  TYPES,
  updateBookingId,
  updateEditNames,
  updateEditNameStep,
  updateSelectedBookingPassenger,
};
